import type { FaireOrderEntity } from "../../entity_types/order";

export const FVUZESMSDC: FaireOrderEntity = {
  token: "FVUZESMSDC",
  type: "order",
  orderNumber: "#FVUZESMSDC",
  status: "fulfilled",
  totalDollars: 131.6,
  customerName: "Lavender & Sage Co.",
  firstOrder: false,
  placedAt: "Dec 1, 2025",
  shipBy: "Sep 3, 2025",
  sourceLabel: "Faire Direct",
  payoutDate: "Dec 1, 2025",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
